<script>
  $: title = "Sticky Games";

  $: {
    document.title = title;
  }

  let mobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  let isAndroid = /Android/i.test(navigator.userAgent);
  let isIphone = /iPhone|iPad/i.test(navigator.userAgent);

  let primaryColor = "#F6B000";
  let secondaryColor = "#2DB6E9";
  let yellowDarkColor = "#E05E00";
  let logo = "gfx/Logo.svg";
  let promoImage = "gfx/WBimagePromo.png";
  let iosDownloadLinkButton = "gfx/download_on_appstore.png";
  let androidDownloadLinkButton = "gfx/playstore_btn@2x.png";
  let separatorDiamondPrimary = "gfx/SeparatorDiamondPrimary.png";
  let separatorDiamondSecondary = "gfx/SeparatorDiamondSecondary.png";
</script>

<main>
  <div style="background-color:{primaryColor}">
    <div class="topSection" style="background-color:{primaryColor};">
      <img class="logo" src={logo} alt="Logo" />

      <h2 class="headerTextMedium ourGames">Our Games</h2>
      <img
        class="separatorDiamond"
        src={separatorDiamondPrimary}
        alt="separator"
      />
    </div>

    <div class="middleSection" style="background-color:{secondaryColor}">
      <div class="middleRightSection">
        <div class="middleRightContainer">
          <img class="promoImage" src={promoImage} alt="Promo" />
        </div>
      </div>

      <div class="middleLeftSection">
        <div class="middleLeftContainer">
          <h2 class="headerTextMedium whitetext">
            Are you a true Word Master?
          </h2>
          <h3 class="bodyText">
            Join the Lingo Lords community and test your linguistic brain
            muscles against your word nerdy peers!
          </h3>
          <a
            href="https://apps.apple.com/se/app/lingo-lords/id1589969246"
            class="viewGameButton"
            ><img
              style="margin-top:16px"
              src={iosDownloadLinkButton}
              alt="iOS Download"
            /></a
          >
          <a
            href="https://play.google.com/store/apps/details?id=com.stickygames.lingolords"
            class="viewGameButton"
            ><img
              style="margin-top:16px"
              src={androidDownloadLinkButton}
              alt="Android Download"
            /></a
          >
        </div>
      </div>

      <img
        class="separatorDiamond"
        src={separatorDiamondSecondary}
        alt="separator"
      />
    </div>

    <div class="bottomSection">
      <div class="bottomSectionText">
        <h2 class="headerTextMedium textCentered">
          Questions? Feedback? Love? Contact us!
        </h2>
        <h2 class="headerTextMedium textCentered" style="color:white">
          <a href="mailto:support@sticky.games">support@sticky.games</a>
        </h2>
        <div>
          <h2 class="headerTextMedium textCentered">
            Or catch us on
            <a
              href="https://www.facebook.com/WordBlocks-104340357967267"
              style="color:white underline:false"
            >
              Facebook
            </a>
          </h2>
        </div>
      </div>
    </div>
  </div>
</main>

<style>
  :global(body) {
    background: #f6b000;
    padding: 0px;
    margin: 0px;
  }

  :global(html, body) {
    max-width: 100%;
    overflow-x: hidden;
  }

  /* unvisited link */
  a:link {
    color: white;
  }

  /* visited link */
  a:visited {
    color: white;
  }

  /* mouse over link */
  a:hover {
    color: white;
  }

  /* selected link */
  a:active {
    color: white;
  }

  a:link {
    text-decoration: none;
  }

  a:visited {
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  a:active {
    text-decoration: underline;
  }

  @font-face {
    font-family: "Oxygen-Bold";
    src: url("/fonts/oxygen-bold-webfont.woff") format("woff");
    src: url("/fonts/oxygen-bold-webfont.woff2") format("woff2");
  }

  @font-face {
    font-family: "GROBOLD";
    src: url("/fonts/grobold-webfont.woff") format("woff");
    src: url("/fonts/grobold-webfont.woff2") format("woff2");
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }

  h1,
  h2,
  h3,
  body {
    /* this allows the children to inherit this style */
    -webkit-font-smoothing: antialiased;
  }

  .grid-container {
    display: grid;
    grid-template-areas:
      "header header header header"
      "header2 header2 header2 header2"
      "middleSection middleSection middleSection middleSection"
      "bottomSectionDivider bottomSectionDivider bottomSectionDivider bottomSectionDivider"
      "footer footer footer footer";
    padding: 0px;
  }

  .topSection {
    height: 90vh;
    position: relative;
  }

  .logo {
    width: 600px;
    max-width: 67%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .topSectionLower {
    height: 10vh;
    display: flex;
    justify-content: center;
    position: relative;
  }

  .middleSection {
    width: 100%;
    height: 90vh;
    padding: 0px;
    position: relative;
  }

  .middleLeftSection {
    width: 50%;
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0px;
  }
  .middleLeftContainer {
    padding: 0 32px 0 80px;
  }

  .middleRightSection {
    width: 50%;
    float: right;
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 0px;
  }

  .middleRightContainer {
    padding: 0;
  }

  .middleLeftGridContainer {
    display: grid;
    grid-template-areas:
      "headerTextBig"
      "bodyText"
      "viewGameButton";
    width: 100%;
    /* padding-left: 20%; */
  }

  .bottomSection {
    height: 90vh;
    position: relative;
  }

  .bottomSectionText {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    padding: 0 24px;
  }

  .viewGameButton {
    object-fit: cover;
    width: 30%;
    width: 100%;
  }

  .promoImage {
    object-fit: contain;
    max-width: 50vw;
    height: 50vh;
    align-self: center;
    text-align: right;
  }

  .separatorDiamond {
    bottom: -16px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
    z-index: 999;
  }

  .headerTextBig {
    font-family: GROBOLD;
    font-size: 64px;
    line-height: 64px;
    color: white;
    position: relative;
  }

  .headerTextMedium {
    font-family: GROBOLD;
    font-size: 40px;
    line-height: 48px;
    font-weight: 700;
    color: white;
    position: relative;
    padding: 0 24px;
    color: #e05e00;
  }

  .bodyText {
    grid-area: bodyText;
    font-family: Oxygen-Bold;
    font-size: 18px;
    line-height: 23px;
    color: white;
  }

  .textCentered {
    text-align: center;
  }
  .whitetext {
    color: #ffffff;
  }
  .ourGames {
    margin: 0;
    bottom: 48px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
  }

  @media only screen and (max-width: 1023px) {
    .headerTextMedium {
      font-size: 24px;
      line-height: 30px;
    }

    .headerTextBig {
      font-size: 28px;
      line-height: 28px;
    }

    .middleSection {
      height: auto;
    }

    .middleLeftSection {
      width: 100%;
      float: none;
      top: auto;
      position: relative;
      transform: none;
    }
    .middleLeftContainer {
      padding: 12px 24px 80px 24px;
      text-align: center;
    }

    .middleRightSection {
      width: 100%;
      float: none;
      top: auto;
      position: relative;
      transform: none;
    }

    .middleRightContainer {
      padding: 80px 0 12px 7%;
    }

    .promoImage {
      max-width: 100%;
      height: auto;
    }
  }
  .ourGames {
    bottom: 24px;
    width: 100%;
    text-align: center;
  }
</style>
